/**
 * Created by andrey on 30.09.2025
 */

const PlayInTwoTabs = function () {
    this.resetSession();

    cleverapps.dataLoader.onBeforeSaveListener = () => this.checkSession();

    this.checkSessionThrottled = cleverapps.throttle(500, () => this.checkSession());

    connector.synchronizer.on("changeStatus", () => this.checkSessionThrottled());
    connector.platform.on("resume", () => this.checkSessionThrottled());
};

PlayInTwoTabs.prototype.checkSession = function () {
    if (this.sessionExpired) {
        return;
    }

    if (cleverapps.isLocalhost() || this.session === undefined
        || cleverapps.config.importMode || cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    let session;

    try {
        session = cleverapps.dataLoader.localStorage.getItem(DataLoader.TYPES.CLIENT_SESSION);
    } catch (e) {
        console.warn("can't read session", e);
        return;
    }

    if (session && session !== this.session) {
        this.setSessionExpired();
    }
};

// false once another tab took the session: nothing this tab grants is saved any more
PlayInTwoTabs.prototype.isSessionAlive = function () {
    this.checkSession();
    return !this.sessionExpired;
};

PlayInTwoTabs.prototype.resetSession = function () {
    this.session = undefined;

    if (!connector.info.isNative) {
        this.session = `${Math.floor(Math.random() * 1000000000) + 1}`;
        cleverapps.dataLoader._saveProcess(DataLoader.TYPES.CLIENT_SESSION, this.session, { raw: true });
        cleverapps.dataLoader.saveChecksum();

        if (!cleverapps.dataLoader.enabled) {
            this.session = undefined;
        }
    }
};

PlayInTwoTabs.prototype.setSessionExpired = function () {
    if (this.sessionExpired) {
        return;
    }

    this.sessionExpired = true;
    this.wantsTwoTabsWindow = true;

    cleverapps.dataLoader.setEnabled(false);
    connector.dataLoader.setEnabled(false);
    connector.synchronizer.disable();

    if (cleverapps.metrics) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.CLEARANCE.LOCALSTORAGE_SESSION_EXPIRED);
    }

    cleverapps.placements.run(Placements.SYSTEM_FAULT);
};
